import React, { useState } from "react";
import RequestBuy from "../components/common/requestForm/RequestBuy";
import CompareSelect from "../components/layout/CompareSelect";
import RequestGetList from "../components/common/requestForm/RequestGetList";
import { FaTimes } from "react-icons/fa";
import { Helmet } from "react-helmet";
import { useRouteInfo } from "../hooks/useRouteInfo";

const ComparePage = () => {
  const { metaData } = useRouteInfo();

  return (
    <div className="pb-8 pt-12 w-full container_1">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaData?.meta_title}</title>
        <meta name="description" content={metaData?.meta_desc} />
        <meta name="og:description" content={metaData?.meta_desc} />
        <meta name="og:title" content={metaData?.meta_title} />
        <link rel="canonical" href={metaData?.canonical} />
        <meta property="og:type" content={metaData?.meta_type} />
      </Helmet>{" "}
      <RequestBuy />
      <CompareSelect metaData={metaData} />
      <div className="mt-36">
        <RequestGetList />
      </div>
    </div>
  );
};

export default ComparePage;
